import { gsap } from 'gsap';
import { debounce as _debounce } from 'underscore';
//import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
//import { ScrollTrigger } from 'gsap/ScrollTrigger';
//gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false,
        	ajax:  true,
        	class_fade: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'module_page_filters';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;
		this.$win 			= 	$(window);

		this.$form 			=   this.$el.find( 'form.filters' );
		this.class_ajax 	= 	this.$el.attr( 'data-ajax-view' );
		this.$view 			= 	$( '.' + this.class_ajax);
		this.class_fade 	=   this.options.class_fade?this.options.class_fade:this.class_ajax;

		this.loading 		= 	false;
		this.history  		= 	window.history;


		if ( this.$el.hasClass( 'mode-search-query' ) ){
			this.is_search 	= true;
			this.url 	  	=  this.$form.attr( 'action' );
		}

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.addEvents( true );
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
			this.$el.find( '.filter' ).on( 'change', (e) => this.onFilterChange(e) );
		}
		else{
			this.$el.find( '.filter' ).off( 'change', (e) => this.onFilterChange(e) );
		}
		if ( this.options.ajax ){
			this.initFormAjax( b );
			this.initResetFilters( b );
			//this.initPaginationAjax( b );
		}
		this.debounceResize(b);
		//this.modifySearchForm();
	}

	modifySearchForm(){
		let $search = this.$el.find( '.module-search-form' );
		if ( $search.length > 0 ){
			$search.on( 'submit', (e)=>{
				e.preventDefault();
				return false;
			} )
		}
	}

    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 137 );
            this.$win.on( 'resize', this._debResize );
            this.onResize()
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    // where the magic happen
    onResize(){
    	let $search = this.$el.find( '.module-search-form' );
    	if ( $search.length > 0 ){
    		$search.width( this.$el.find( '.filter' ).width() );
    	}
 	}

	onFilterChange(e){
        this.$form.submit();
 	}

 	initFormAjax( b ){
 		if ( b ){
 			this.$form.on( 'submit', (e)=>this.onSubmitForm(e, this.$form.attr( 'action' ) ) );
 		}
 		else{
 			this.$form.off( 'submit', (e)=>this.onSubmitForm(e, this.$form.attr( 'action' ) ) );
 		}
 	}

 	initResetFilters( b ){
 		let $a = $( '.reset-all-filters' );
 		if ( $a.length <= 0 ){
 			return;
 		}
 		if ( b ){
 			$a.on( 'click', (e)=>this.onSubmitForm(e, $a.attr( 'href' ), true ) );
 		}
 		else{
 			$a.off( 'click', (e)=>this.onSubmitForm(e, $a.attr( 'href' ), true ) );
 		}
 	}

	onSubmitForm( e, url, reset=false ){
		e.preventDefault();

		if ( this.loading ){
			return;
		}

		let obj;

		this.$form.css({
			'pointer-events'  : 'none'
		})
		this.loading = true;
		this.main.setLoading( true );

		//gsap.to( this.$view, {opacity:0.5, duration:0.4, ease: 'power.easeOut' } );
		this.fadeInterfaceOnLoading( true );


		console.log( url + this.$form.serialize() );

		obj = {
	      	type: "GET",
	      	url: url,
	      	data: reset ? false : this.$form.serialize(),
	    };

	    /*
	    if ( this.is_search ){

	    }
		*/

		$.ajax( obj ).done(		(data) 	=> this.onAjaxLoad(data)
		).fail(		()		=>this.onError()		

	    );

	    //console.log( url );
	    //console.log( this.$form.serialize() );

	    if ( this.history && window.location.href !==  url ){
	    	/*
	    	this.history.pushState({
	    		additionalInformation: 'Updated the URL with JS'
	    	}, $('title').html() , url +  (reset ? '' : '?' + this.$form.serialize()) );
	    	*/
	    	this.history.replaceState({additionalInformation: 'Updated the URL with JS'}, $('title').html() , url );
	    }

  	}

  	onAjaxLoad( data ){

  		let $view =  $(data).find(  '.' + this.class_ajax  );

  		if ( $view.length > 0 ){

	  		this.$view.html( $view.html() );

	  		//gsap.to( this.$view, {opacity:1, duration:0.8, ease: 'power.easeOut' } );
	  		this.fadeInterfaceOnLoading( false );

			//this.destroy();

	  		this.reInitAfterAddContent(); 
	  		 			
  		}
  		else{

  			this.onError( 'view class not found' );
  		}

  	}


  	fadeInterfaceOnLoading(b){
  		let $interface = $( '.' +  this.class_fade );

 		if ( $interface.length > 0 ){
	  		gsap.to( $interface, {opacity: b ? 0.1 : 1, duration:0.8, ease: 'power.easeOut' } );
  		}

  	}

  	onError( str ){
  		//console.log( str );
	
		this.loading = false;
		this.main.setLoading( false );
		//gsap.to( this.$view, {opacity:1, duration:0.2, ease: 'power.easeOut' } );
		this.fadeInterfaceOnLoading( false );
  	}


  	reInitAfterAddContent(){

  		//this.main.WIDGETS.initPageFilters(true);

  		//this.main.WIDGETS.initPackeryGrids(true);
  		

		this.loading = false;

		this.main.setLoading( false );

		this.$form.css({
			'pointer-events'  : 'auto'
		});

		this.initResetFilters( true )

  	}

  	initPaginationAjax( b ){
  		let $pagination = $( '.pagination' );
  		if ( $pagination.length > 0 ){
  			if ( b ){
  				$pagination.find( 'a' ).addClass( 'no-barba' ).on( 'click', (e)=>this.onSubmitForm( e, $(e.currentTarget).attr( 'href' ) ) );
  			}
  			else{
  				$pagination.find( 'a' ).off( 'click', (e)=>this.onSubmitForm( e, $(e.currentTarget).attr( 'href' ) ) );
  			}
  		}
  	}

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
		if ( this.$el.length > 0 ){
    		this.addEvents( false );
    	}
    }

}


